import { useMemo } from 'react'
import { useGetProductSources } from 'domains/products/api/getProductSources.hooks'
import { type ProductSource, type SourceLevel } from 'domains/products/api/index'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { sourceTypeAllSources } from 'domains/products/components/view/types/attributeOverride.types'

export const useGetProductSourceOptions = (sourceLevel: SourceLevel) => {
  const messages = useDomainMessages({
    allSources: 'productsDomain.attributeOverride.sources.allSources',
  })

  const {
    sources,
    apiError: apiError,
    apiLoading: apiLoading,
    apiRefetch: apiRefetch,
  } = useGetProductSources({
    sourceLevel: sourceLevel,
  })

  const sourceOptions = useMemo(
    () => createSourceOptions(sources as Array<ProductSource>, messages.allSources),
    [sources, messages]
  )

  return {
    sourceOptions,
    sourceOptionsError: apiError,
    sourceOptionsLoading: apiLoading,
    sourceOptionsRefetch: apiRefetch,
  }
}

const createSourceOptions = (sources: ProductSource[], allSourcesLabel: string) => {
  if (!sources) {
    return []
  }

  const sourceOptions = sources.map(currentSource => ({
    label: currentSource.name,
    value: currentSource.name,
  }))

  sourceOptions.unshift({
    label: allSourcesLabel,
    value: sourceTypeAllSources,
  })

  return sourceOptions
}
